/*
 * @Author: wang jun feng
 * @Date: 2020-02-04 14:12:06
 * @LastEditTime : 2020-02-22 21:50:04
 * @LastEditors  : wang jun feng
 */
export default {
  // 上传授权
  uploadAuth: {
    // url: '/userauth/userLogin/getAccessoryToken',
    url: '/userauth/assist/getAccessoryToken',
    type: 'get',
    parameter: {}
  },
  // 上传初始化
  uploadInit: {
    url: 'file/upload/init',
    type: 'post',
    parameter: {
      token: String, // 上传临时令牌
      fileSize: String, // 上传文件大小
      originalName: String // 上传文件名
    }
  },
  // 批量初始化
  uploadBatchInit: {
    url: 'file/upload/init/batch',
    type: 'post',
    parameter: [
      {
        'system': 'supplier_web',
        'originalName': '测试.xls',
        'userinfo': '88888888',
        'business': 'order_file',
        'fileSize': 13173
      },
      {
        'system': 'supplier_web',
        'originalName': '测试2.xls',
        'userinfo': '88888888',
        'business': 'order_file',
        'fileSize': 13173
      }
    ]
  },
  // 上传
  upload: {
    url: 'file/upload/part',
    type: 'post',
    parameter: {
      token: String, // 上传临时令牌
      name: String, // 文件名称
      chunk: Number, // 分片编号
      file: 'File', // 上传文件
      partMd5: String // 上传文件md5编码
    }
  },
  // 上传完成
  complete: {
    url: 'file/upload/complete',
    type: 'post',
    parameter: {
      token: String, // 上传临时令牌
      originalName: String  // 文件名称
    }
  }
}
